document.addEventListener("DOMContentLoaded", function() {

    let button = document.getElementsByClassName('JS-searchHeader')[0],
        search = document.getElementsByClassName('JS-searchHeaderBox')[0],
        input = document.getElementsByClassName('js-globalsearch')[0];

    button.addEventListener("click", function(){
        search.classList.toggle('isOpen');
    });

    search.addEventListener("click", function() {
        search.classList.remove('isOpen');
    });

    input.addEventListener("click", function(e) {
        e.stopPropagation();
    });
});
